// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"9da3b99f","617":"43f1b931"}[chunkId] + ".chunk.css";
};